
import { Card, CardContent, Divider, FormControl, Grid, Select, TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import FilesPreview from 'src/components/FilePreview';
import axios from 'src/utils/axios';
import { loadFotograf } from 'src/utils/storage/StrPhoto';
import CamPopup from '../../components/CamPopup';
import FilePopup from '../../components/FilePopup';
import CCFilePopup from '../../components/CCFilePopup';
import AlertYasal from '@material-ui/lab/Alert';
import MonochromePhotosIcon from '@material-ui/icons/MonochromePhotos';
import logger from 'src/utils/logger';



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  content: {
    minHeight: 330,
  },

  formControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function Detay({ FisNo }) {
  const [Loading, setLoading] = useState(true);
  const [openCam, setOpenCam] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [DosyaTipi, setDosyaTipi] = useState();
  const [DosyaIsmi, setDosyaIsmi] = useState("");
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [files, setFiles] = React.useState([]);
  const [CCFilePopupOpen, setCCFilePopupOpen] = React.useState(false);

  const DosyaTipihandleChange = (event) => {
    var index = event.target.selectedIndex;
    setDosyaIsmi(event.target[index].text);
    setDosyaTipi(event.target.value);
  };
  const handleChangeDosyaIsmi = (event) => {
    const { value } = event.target;
    setDosyaIsmi(value);
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const classes = useStyles();
  const handleCamOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: "Lütfen Dosya Tipi Seçiniz!..." })
      setUyariTip("error");
      setUyari(true);
      return;
    }
    setOpenCam(true);
  }
  const handleCamClose = (type) => {
    if (type === 'file') {
      setOpenFile(false);
    } else {
      setOpenCam(false);
    }
    setLoading(true);
    const localPhotos = loadFotograf(FisNo);
    setFiles(localPhotos);
    axios.get('/GetArtemisDosyaListe/' + FisNo).then((response) => {
      if (response.data === "") {
        setLoading(false);
        setFiles(localPhotos);
      } else {
        const Deger = response.data;
        setFiles([...Deger, ...localPhotos]);
        setLoading(false);
      }
    }).catch(error => {
      setFiles(localPhotos);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
  }
  const handleFileOpen = () => {
    if (DosyaTipi === undefined) {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: "Lütfen Dosya Tipi Seçiniz!..." })
      setUyariTip("error");
      setUyari(true);
      return;
    }
    setOpenFile(true);
  }
  const handleFileClose = () => {
    handleCamClose('file');
  }
  const handleCCFileClose = () => {
    setCCFilePopupOpen(false);
  }

  const fetchPhotos = (mounted) => {
    setLoading(true);
    const localPhotos = loadFotograf(FisNo);



    setFiles(localPhotos);
    axios.get('/GetArtemisDosyaListe/' + FisNo).then((response) => {
      if (mounted) {
        if (response.data === "") {
          setFiles(localPhotos);
          setLoading(false);
        } else {
          const Deger = response.data;
          setFiles([...Deger, ...localPhotos]);
          setLoading(false);
        }
      }
    }).catch(error => {
      setFiles(localPhotos);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
  };
  useEffect(() => {
    let mounted = true;
    // setLoading(true);
    fetchPhotos(mounted);
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [FisNo]);
  return (
    <Card>
      <CardContent>
        {
          uyari ?
            <Alert onClose={uyariKapat} open={uyari} message={responseMessage.ErrorDescription} variant={uyariTip} />
            : <div></div>
        }
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item xs={4} align="left">
            <IconButton aria-label="settings" onClick={handleCamOpen}>
              <AddAPhotoIcon color="primary"></AddAPhotoIcon>
            </IconButton>
          </Grid>
          <Grid item xs={4} align="center">
            <IconButton aria-label="settings"
              // onClick={setCCFilePopupOpen(true)}
              onClick={() => setCCFilePopupOpen(true)}
            >
              <MonochromePhotosIcon color="secondary"></MonochromePhotosIcon>
            </IconButton>
          </Grid>
          <Grid item xs={4} align="right">
            <IconButton aria-label="settings" onClick={handleFileOpen}>
              <AttachmentIcon color="primary"></AttachmentIcon>
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            fullWidth
            native
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={DosyaTipi}
            // disabled={readonly}
            onChange={DosyaTipihandleChange}
          >
            <option value={0}>Seçim Yapınız!...</option>
            <option value={22}>Ürün Fotoğrafları</option>
            <option value={19}>Ürün Ambalaj Fotoğrafları</option>
            <option value={13}>Komponent Fotoğrafı</option>
            <option value={20}>Ürün Barkod veya Tip Etiketi Fotoğrafı</option>
            <option value={23}>Ürün Garanti Belgesi</option>
            <option value={24}>Ürün Satış Faturası/Fişi/İrsaliyesi</option>
            <option value={3}>Ek Garanti Sertifikası</option>
            <option value={14}>ÖKC Dokumanı</option>
            <option value={12}>Keşif Formu</option>
            <option value={8}>İlk Çalıştırma Kontrol Formu</option>
            <option value={16}>Testo Raporu</option>
            <option value={15}>Test Raporu(Gaz kaçak, PC Doctor, TKM vb.)</option>
            <option value={4}>Etkinlik Kontrol Formu(Yıkama, Pişirme vb.)</option>
            <option value={5}>Gaz Dağıtım Firması Dokumanı</option>
            <option value={7}>Hasar Tazmin Protokolü</option>
            <option value={9}>İtfaiye/Jandarma/Polis Tutanağı</option>
            <option value={17}>Tüketici Banka Hesap Bilgileri</option>
            <option value={18}>Tüketiciyle Yapılan Ürün/Satış/Montaj Sözleşmesi</option>
            <option value={27}>Ürün Değişim Kabul Fotoğrafı</option>
            <option value={28}>Tespit Videosu</option>
            <option value={26}>Diğer</option>
          </Select>
        </FormControl>
        <br />
        <br />
        <TextField
          label="Dosya İsmi"
          fullWidth
          name="DosyaIsmi"
          autoComplete="off"
          value={DosyaIsmi}
          onChange={handleChangeDosyaIsmi}
          variant="outlined"
        />
        <br />
        <br />
        <AlertYasal severity="warning">{"Gönderdiğiniz dosyada, müşteri kişisel bilgileri (ad, soyad, TCKN, adres, telefon numarası) olmadığından emin olunuz."}</AlertYasal>
      </CardContent>
      <Divider className={classes.divider} />
      <CardContent className={classes.content}>
        {
          Loading ?
            <CircularProgress status={'loading'} style={{ marginLeft: '50%' }} />
            : <div></div>
        }
        <FilesPreview FisNo={FisNo} files={files} fetchPhotos={fetchPhotos} setLoading={setLoading} />
      </CardContent>

      <CamPopup
        onClose={handleCamClose}
        FisNo={FisNo}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        open={openCam}
      />
      <FilePopup
        onClose={handleFileClose}
        FisNo={FisNo}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        open={openFile}
      />
      <CCFilePopup
        onClose={handleCCFileClose}
        FisNo={FisNo}
        open={CCFilePopupOpen}
      />

    </Card>

  );
}

Detay.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(Detay);
